import {Component, ViewChild} from "@angular/core";
import {AsiTable, AsiTableData, AsiTableRequest} from "@asi-ngtools/lib";
import {
  CommandeMaterielDto,
  CorrespondantDetailsDto,
  ICommandeMaterielWebServiceClient,
  LigneCommandeMaterielDto
} from "@resources/resources";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {ArianeElement, ArianeStore} from "@digicerba/common";

@Component({
  selector: 'historique-detail-component',
  templateUrl: './historique-detail.component.html',
  host: { 'class': 'page' }
})
export class HistoriqueDetailPageComponent {

  @ViewChild('cmHistoriqueDetailDataTable') historiqueDetailTable: AsiTable<LigneCommandeMaterielDto>;

  detail: CommandeMaterielDto = null;
  correspondantDetails: CorrespondantDetailsDto = null;


  constructor(private arianeStore: ArianeStore, private translateService: TranslateService, private activatedRoute: ActivatedRoute,
              private commandeMaterielWebService: ICommandeMaterielWebServiceClient,
              private router: Router) {
  }

  private initArianne(detail: CommandeMaterielDto) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.HISTORIQUE_COMMANDE.historiqueCommande",
        route: "/historique"
      },
      {
        libelle: this.translateService.instant("ARIANNE.HISTORIQUE_COMMANDE.historiqueDetail", {identifiant: detail.id}),
        route: "/historique/" + detail.id
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.detail = this.activatedRoute.snapshot.data['detail'];
    this.initArianne(this.detail);
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    let asiTableData: AsiTableData<LigneCommandeMaterielDto> = new AsiTableData<LigneCommandeMaterielDto>();
    asiTableData.results = this.detail.lignes;
    this.historiqueDetailTable.updateData(asiTableData);
  }

  isEnCoursValidation(): boolean {
    return this.detail.etat == 'EN_COURS_VALIDATION';
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/historique-detail/historique-detail.component.ts